import React, { useEffect, useState, useMemo } from "react";
import * as Mui from "@mui/material";
import { Cancel, AddCircleTwoTone } from "@material-ui/icons";
import {
  employee_use,
  tableHeaderSx,
  tableRowSx,
} from "services/constants";
import { themes } from "services/constants";
import { useForm } from "react-hook-form";
import { minimum3Characters } from "services/constants/ErrorMessages";
import { CustomTextBox } from "components/CustomComponents/CustomTextBox";
import { showToast } from "services/utils/Status";
import {
  specialCharacterRestrict,
  onlyNumberRegex,
  aadharRegex,
  panRegex,
  mustbe12Digits,
  ifscCodePatterns,
} from "services/constants/patterns";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";
import { setEditPage } from "services/Redux/HRPortal";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { customAPI } from "services/utils/CustomAPI";
import { Info } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { tooltipStyleProps } from "services/constants/Styles";
export const PersonalInfo = ({
  pageno,
  employeeDetails,
  setUpdateUserDetails,
  getSelectedUserDetails,
  updateUserDetails,
  onFieldCheck,
}) => {
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  const initialValues = useMemo(
    () => ({
      user_id: employeeDetails.user_id,
      aadhar: employeeDetails?.aadhar ? employeeDetails?.aadhar : "",
      pan: employeeDetails?.pan ? employeeDetails?.pan : "",
      pf: employeeDetails?.pf ? employeeDetails?.pf : "",
      esi: employeeDetails?.esi ? employeeDetails?.esi : "",
      uan: employeeDetails?.uan ? employeeDetails?.uan : "",
      dob: employeeDetails?.dob
        ? employeeDetails?.dob?.split("-").reverse().join("-")
        : null,
      address: employeeDetails?.address ? employeeDetails?.address : "",
      bankname: employeeDetails.bankname ? employeeDetails.bankname : "",
      account_holder_name: employeeDetails.account_holder_name
        ? employeeDetails.account_holder_name
        : "",
      accountno: employeeDetails.accountno ? employeeDetails.accountno : "",
      block_name: employeeDetails?.block_name
        ? employeeDetails?.block_name
        : "",
      ifsc: employeeDetails.ifsc ? employeeDetails.ifsc : "",
      bank_address: employeeDetails?.bank_address
        ? employeeDetails?.bank_address
        : "",
      permanent_address: employeeDetails?.permanent_address
        ? employeeDetails?.permanent_address
        : "",
      gender: employeeDetails?.gender ? employeeDetails?.gender : "",
      marital_status: employeeDetails?.marital_status
        ? employeeDetails?.marital_status
        : "",
      transport_type: employeeDetails?.transport_type
        ? employeeDetails?.transport_type
        : "Company accommodation",
      transport_route_no: employeeDetails?.transport_route_no
        ? employeeDetails?.transport_route_no
        : "",
      room_no: employeeDetails?.room_no ? employeeDetails?.room_no : "",
    }),
    [
      employeeDetails?.aadhar,
      employeeDetails.account_holder_name,
      employeeDetails.accountno,
      employeeDetails?.address,
      employeeDetails?.bank_address,
      employeeDetails.bankname,
      employeeDetails?.block_name,
      employeeDetails?.dob,
      employeeDetails?.esi,
      employeeDetails?.gender,
      employeeDetails.ifsc,
      employeeDetails?.marital_status,
      employeeDetails?.pan,
      employeeDetails?.permanent_address,
      employeeDetails?.pf,
      employeeDetails?.room_no,
      employeeDetails?.transport_route_no,
      employeeDetails?.transport_type,
      employeeDetails?.uan,
      employeeDetails.user_id,
    ],
  );

  // Emergency contacts live in a dynamic table (see `rows` state below) that
  // is not wired into react-hook-form, mirroring the drawer's
  // EditEmpPersonalInfo.js. Track the as-loaded contacts separately so the
  // "unsaved changes" check further below can still detect edits to them.
  const initialEmergencyContacts = useMemo(() => {
    const apiContacts = employeeDetails?.emergency_contacts || [];
    return apiContacts.length
      ? apiContacts.map((item) => ({
          contact_name: item.contact_name || "",
          relation_type: item.relation_type || "",
          contact_number: item.contact_number || "",
        }))
      : [{ contact_name: "", relation_type: "", contact_number: "" }];
  }, [employeeDetails?.emergency_contacts]);

  const dispatch = useDispatch();
  const { domain, token } = useSelector((state) => state.tokenReducer);
  const history = useHistory();
  const watchAllFields = watch();
  const [aadharNo, setAadharNo] = useState(
    employeeDetails?.aadhar ? employeeDetails?.aadhar : "",
  );
  const [panNo, setPanNo] = useState(
    employeeDetails?.pan ? employeeDetails?.pan : "",
  );
  const [pfNo, setPFNo] = useState(
    employeeDetails?.pf ? employeeDetails?.pf : "",
  );
  const [esiNo, setESINo] = useState(
    employeeDetails?.esi ? employeeDetails?.esi : "",
  );
  const [uanNo, setUANNo] = useState(
    employeeDetails?.uan ? employeeDetails?.uan : "",
  );
  const [dateOfBirth, setDateOfBirth] = useState(
    employeeDetails?.dob
      ? employeeDetails?.dob?.split("-").reverse().join("-")
      : null,
  );
  const [addressDetails, setAddressDetails] = useState(
    employeeDetails?.address ? employeeDetails?.address : "",
  );

  const [bankNameDetails, setBankNameDetails] = useState(
    employeeDetails.bankname ? employeeDetails.bankname : "",
  );
  const [accountNameDetails, setAccountNameDetails] = useState(
    employeeDetails.account_holder_name
      ? employeeDetails.account_holder_name
      : "",
  );
  const [accountNumber, setAccountNumber] = useState(
    employeeDetails.accountno ? employeeDetails.accountno : "",
  );
  const [ifscCodeDetails, setIFSCcodeDetails] = useState(
    employeeDetails.ifsc ? employeeDetails.ifsc : "",
  );
  const [bankAddress, setBankAddress] = useState(
    employeeDetails?.bank_address ? employeeDetails?.bank_address : "",
  );
  const [saveAndExit, setSaveAndExit] = useState(false);
  const [permanentAddressDetails, setPermanentAddressDetails] = useState(
    employeeDetails?.permanent_address
      ? employeeDetails?.permanent_address
      : "",
  );
  const [rows, setRows] = useState(
    employeeDetails?.emergency_contacts?.length
      ? employeeDetails.emergency_contacts.map((item) => ({
          contact_name: item.contact_name || "",
          relation_type: item.relation_type || "",
          contact_number: item.contact_number || "",
        }))
      : [{ contact_name: "", relation_type: "", contact_number: "" }],
  );
  const [rowError, setRowError] = useState([
    { contact_name: false, relation_type: false, contact_number: false },
  ]);
  const [genderType, setGenderType] = useState(
    employeeDetails?.gender ? employeeDetails?.gender : "",
  );
  const [maritialSts, setMaritialSts] = useState(
    employeeDetails?.marital_status ? employeeDetails?.marital_status : "",
  );
  const { result: gender_type } = useFetch(`${domain}get-gender-choices/`);
  const { result: maritial_status } = useFetch(
    `${domain}get-marital-choices/`,
  );
  const [employeeUse, setEmployeeUse] = useState(
    employeeDetails?.transport_type
      ? employeeDetails?.transport_type
      : "Company accommodation",
  );
  const [blockNo, setBlockNo] = useState(
    employeeDetails?.block_name ? employeeDetails?.block_name : "",
  );
  const [roomNo, setRoomNo] = useState(
    employeeDetails?.room_no ? employeeDetails?.room_no : "",
  );
  const [transportRouteNumber, setTransportRouteNumber] = useState(
    employeeDetails?.transport_route_no
      ? employeeDetails?.transport_route_no
      : "",
  );
  const [communicationAddressCheckBox, setCommunicationAddressCheckBox] =
    useState(
      employeeDetails?.permanent_address === employeeDetails?.address &&
        employeeDetails?.permanent_address
        ? true
        : false,
    );

  useEffect(() => {
    const hasChanged =
      Object.keys(initialValues).some(
        (key) => watchAllFields[key] !== initialValues[key],
      ) || JSON.stringify(rows) !== JSON.stringify(initialEmergencyContacts);
    onFieldCheck(hasChanged);
  }, [initialValues, initialEmergencyContacts, onFieldCheck, rows, watchAllFields]);

  useEffect(() => {
    const updateData = () => {
      setValue("user_id", employeeDetails.user_id);
      setValue(
        "aadhar",
        employeeDetails?.aadhar ? employeeDetails?.aadhar : "",
      );
      setValue("pan", employeeDetails?.pan ? employeeDetails?.pan : "");
      setValue("pf", employeeDetails?.pf ? employeeDetails?.pf : "");
      setValue("esi", employeeDetails?.esi ? employeeDetails?.esi : "");
      setValue("uan", employeeDetails?.uan ? employeeDetails?.uan : "");
      setValue(
        "dob",
        employeeDetails?.dob
          ? employeeDetails?.dob?.split("-").reverse().join("-")
          : null,
      );
      setValue(
        "address",
        employeeDetails?.address ? employeeDetails?.address : "",
      );
      setValue(
        "permanent_address",
        employeeDetails?.permanent_address
          ? employeeDetails?.permanent_address
          : "",
      );
      setValue(
        "transport_type",
        employeeDetails?.transport_type
          ? employeeDetails?.transport_type
          : "Company accommodation",
      );
      setValue(
        "transport_route_no",
        employeeDetails?.transport_route_no
          ? employeeDetails?.transport_route_no
          : "",
      );
      setValue(
        "account_holder_name",
        employeeDetails.account_holder_name
          ? employeeDetails.account_holder_name
          : "",
      );
      setValue(
        "bankname",
        employeeDetails.bankname ? employeeDetails.bankname : "",
      );
      setValue(
        "accountno",
        employeeDetails.accountno ? employeeDetails.accountno : "",
      );
      setValue("ifsc", employeeDetails.ifsc ? employeeDetails.ifsc : "");
      setValue(
        "address",
        employeeDetails.address ? employeeDetails.address : "",
      );
      setValue(
        "block_name",
        employeeDetails?.block_name ? employeeDetails?.block_name : "",
      );
      setValue(
        "room_no",
        employeeDetails?.room_no ? employeeDetails?.room_no : "",
      );
      setValue("gender", employeeDetails?.gender ? employeeDetails?.gender : "");
      setValue(
        "marital_status",
        employeeDetails?.marital_status ? employeeDetails?.marital_status : "",
      );
      setValue(
        "bank_address",
        employeeDetails?.bank_address ? employeeDetails?.bank_address : "",
      );

      const apiContacts = employeeDetails?.emergency_contacts || [];
      const formattedRows = apiContacts.length
        ? apiContacts.map((item) => ({
            contact_name: item.contact_name || "",
            relation_type: item.relation_type || "",
            contact_number: item.contact_number || "",
          }))
        : [{ contact_name: "", relation_type: "", contact_number: "" }];
      setRows(formattedRows);

      setAadharNo(employeeDetails?.aadhar ? employeeDetails?.aadhar : "");
      setPanNo(employeeDetails?.pan ? employeeDetails?.pan : "");
      setPFNo(employeeDetails?.pf ? employeeDetails?.pf : "");
      setESINo(employeeDetails?.esi ? employeeDetails?.esi : "");
      setUANNo(employeeDetails?.uan ? employeeDetails?.uan : "");
      setDateOfBirth(
        employeeDetails?.dob
          ? employeeDetails?.dob?.split("-").reverse().join("-")
          : "",
      );
      setAddressDetails(
        employeeDetails?.address ? employeeDetails?.address : "",
      );
      setBankNameDetails(
        employeeDetails.bankname ? employeeDetails.bankname : "",
      );
      setAccountNameDetails(
        employeeDetails.account_holder_name
          ? employeeDetails.account_holder_name
          : "",
      );
      setAccountNumber(
        employeeDetails.accountno ? employeeDetails.accountno : "",
      );
      setIFSCcodeDetails(employeeDetails.ifsc ? employeeDetails.ifsc : "");
      setBankAddress(
        employeeDetails?.bank_address ? employeeDetails?.bank_address : "",
      );
      setPermanentAddressDetails(
        employeeDetails?.permanent_address
          ? employeeDetails?.permanent_address
          : "",
      );
      setGenderType(employeeDetails?.gender ? employeeDetails?.gender : "");
      setMaritialSts(
        employeeDetails?.marital_status ? employeeDetails?.marital_status : "",
      );
      setEmployeeUse(
        employeeDetails?.transport_type
          ? employeeDetails?.transport_type
          : "Company accommodation",
      );
      setBlockNo(
        employeeDetails?.block_name ? employeeDetails?.block_name : "",
      );
      setRoomNo(employeeDetails?.room_no ? employeeDetails?.room_no : "");
      setTransportRouteNumber(
        employeeDetails?.transport_route_no
          ? employeeDetails?.transport_route_no
          : "",
      );
      setCommunicationAddressCheckBox(
        employeeDetails?.permanent_address === employeeDetails?.address &&
          employeeDetails?.permanent_address
          ? true
          : false,
      );

      setUpdateUserDetails(false);
    };
    if (updateUserDetails && pageno === 2 && employeeDetails.length !== 0) {
      updateData();
    }
  });

  const onSubmit = async (data) => {
    const contactData = rows.map((row) => ({
      contact_name: row.contact_name,
      relation_type: row.relation_type,
      contact_number: row.contact_number,
    }));
    const payload = {
      ...data,
      emergency_contacts: contactData,
      email: employeeDetails?.email,
      phone_number: employeeDetails?.phone_number,
    };
    const response = await customAPI(
      `${domain}employee-onboard`,
      "PUT",
      payload,
    );
    if (response.ok) {
      if (saveAndExit) {
        showToast("success", "Employee details updated.");
        history.push("/admin/hrzone/employees");
        reset();
      } else {
        getSelectedUserDetails(data?.user_id);
        dispatch(setEditPage(3));
        reset();
      }
    } else {
      setSaveAndExit(false);
    }
  };

  const updateAadharCode = (event) => {
    if (
      onlyNumberRegex.test(event.target.value) &&
      event.target.value.length <= 12
    ) {
      setValue("aadhar", event.target.value);
      setAadharNo(event.target.value);
    }
  };

  const updatePanNumber = (event) => {
    if (
      specialCharacterRestrict.test(event.target.value) &&
      event.target.value.length <= 10
    ) {
      setValue("pan", event.target.value);
      setPanNo(event.target.value);
    }
  };

  const updatePFNumber = (event) => {
    if (
      specialCharacterRestrict.test(event.target.value) &&
      event.target.value.length <= 30
    ) {
      setValue("pf", event.target.value);
      setPFNo(event.target.value);
    }
  };

  const handleDateOfBirth = (event) => {
    setValue("dob", event.target.value);
    setDateOfBirth(event.target.value);
  };

  const updateAddress = (event) => {
    if (event.target.value.length <= 1024) {
      setValue("address", event.target.value);
      setAddressDetails(event.target.value);
      if (communicationAddressCheckBox) {
        setValue("permanent_address", event.target.value);
        setPermanentAddressDetails(event.target.value);
      }
    }
  };

  const updateBankAddress = (event) => {
    if (event.target.value.length <= 1024) {
      setValue("bank_address", event.target.value);
      setBankAddress(event.target.value);
    }
  };

  const updateUANNumber = (event) => {
    if (
      onlyNumberRegex.test(event.target.value) &&
      event.target.value.length <= 30
    ) {
      setUANNo(event.target.value);
      setValue("uan", event.target.value);
    }
  };

  const updateESINumber = (event) => {
    if (
      onlyNumberRegex.test(event.target.value) &&
      event.target.value.length <= 30
    ) {
      setValue("esi", event.target.value);
      setESINo(event.target.value);
    }
  };

  const handleEmployeeUse = (event, data) => {
    if (data) {
      if (getValues("transport_type") !== data.label) {
        setBlockNo("");
        setTransportRouteNumber("");
        setRoomNo("");
        setValue("block_name", "");
        setValue("room_no", "");
        setValue("transport_route_no", "");
        setValue("transport_type", data.label);
        setEmployeeUse(data.label);
      }
    }
  };

  const updateBlockNumber = (event) => {
    if (event.target.value.length < 32) {
      setValue("block_name", event.target.value);
      setBlockNo(event.target.value);
    }
  };

  const updateRoomNumber = (event) => {
    if (event.target.value.length <= 10) {
      setValue("room_no", event.target.value);
      setRoomNo(event.target.value);
    }
  };

  const updateTransportRouteNumber = (event) => {
    if (event.target.value.length < 32) {
      setValue("transport_route_no", event.target.value);
      setTransportRouteNumber(event.target.value);
    }
  };

  const updatePermanentAddress = (event) => {
    if (event.target.value.length <= 1024) {
      setValue("permanent_address", event.target.value);
      setPermanentAddressDetails(event.target.value);
    }
  };

  const handleAddRow = () => {
    setRows((prev) => [
      ...prev,
      { contact_name: "", relation_type: "", contact_number: "" },
    ]);
    setRowError((prev) => [
      ...prev,
      { contact_name: false, relation_type: false, contact_number: false },
    ]);
  };

  const handleRemoveRow = (index) => {
    setRows((prev) => prev.filter((_, i) => i !== index));
    setRowError((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);

    const updatedErrors = [...rowError];
    if (!updatedErrors[index])
      updatedErrors[index] = {
        contact_name: false,
        relation_type: false,
        contact_number: false,
      };
    updatedErrors[index][field] = false;
    setRowError(updatedErrors);
  };

  const handleGenderType = (event, data) => {
    if (data) {
      if (getValues("gender") !== data.label) {
        setValue("gender", data.label);
        setGenderType(data.label);
      }
    }
  };

  const handleMaritialStatus = (event, data) => {
    if (data) {
      if (getValues("marital_status") !== data.label) {
        setValue("marital_status", data.label);
        setMaritialSts(data.label);
      }
    }
  };

  const updateBankName = (event) => {
    if (
      specialCharacterRestrict.test(event.target.value) &&
      event.target.value.length <= 64
    ) {
      setValue("bankname", event.target.value);
      setBankNameDetails(event.target.value);
    }
  };

  const updateAccountName = (event) => {
    if (
      specialCharacterRestrict.test(event.target.value) &&
      event.target.value.length <= 64
    ) {
      setValue("account_holder_name", event.target.value);
      setAccountNameDetails(event.target.value);
    }
  };

  const updateBankAccountNumber = (event) => {
    if (
      event.target.value.length <= 17 &&
      onlyNumberRegex.test(event.target.value)
    ) {
      setValue("accountno", event.target.value);
      setAccountNumber(event.target.value);
    }
  };

  const updateIFSCcode = (event) => {
    if (
      specialCharacterRestrict.test(event.target.value) &&
      event.target.value.length <= 11
    ) {
      setValue("ifsc", event.target.value);
      setIFSCcodeDetails(event.target.value);
    }
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)} style={{ paddingTop: 10 }}>
        <Mui.Grid
          container
          sx={{
            border: `1px solid ${themes.sidebarDivider}`,
            borderRadius: 3,
            paddingBottom: 1,
          }}
        >
          <Mui.Grid
            container
            sx={{
              borderBottom: `1px solid ${themes.sidebarDivider}`,
              padding: { xs: 0.4, sm: 0.4, md: 0.4, lg: 0.6, xl: 1, xxl: 1 },
            }}
          >
            <Mui.Typography
              sx={{
                fontSize: 20,
                fontWeight: "bold",
                color: themes.headLine,
                paddingLeft: 1,
              }}
            >
              Personal Informations
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid
            container
            sx={{ borderBottom: `1px solid ${themes.sidebarDivider}` }}
          >
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Aadhar number&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Enter the employee's Aadhar (UID) number."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={aadharNo}
                Icons={null}
                rules={{
                  ...register("aadhar", {
                    required: false,
                    pattern: {
                      pattern1: (value) =>
                        aadharRegex.test(value) ||
                        "Enter aadhar in format 123456789012",
                      pattern2: (value) =>
                        mustbe12Digits.test(value) ||
                        "Must be exactly 12 digits",
                    },
                    maxLength: {
                      value: 12,
                      message: "Must be exactly 12 digits",
                    },
                    minLength: {
                      value: 12,
                      message: "Must be exactly 12 digits",
                    },
                  }),
                }}
                updateDataFunction={updateAadharCode}
                placeHolder="Enter the aadhar number"
                errorMessage={
                  errors?.aadhar?.message ? errors?.aadhar?.message : ""
                }
                textBoxError={errors.aadhar ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Pan number&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Enter the employee's Permanent Account Number for tax purposes."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={panNo}
                Icons={null}
                rules={{
                  ...register("pan", {
                    required: false,
                    pattern: {
                      value: panRegex,
                      message: "Enter PAN in format AAAAA9999A",
                    },
                    minLength: {
                      value: 10,
                      message: "Must be exactly 10 characters",
                    },
                    validate: {
                      employeePANAvailable: async (fieldValue) => {
                        if (
                          fieldValue !== "" &&
                          employeeDetails.pan !== fieldValue
                        ) {
                          const response = await fetch(
                            `${domain}unique/identity-numbers/?pan=${fieldValue}`,
                            {
                              method: "GET",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `token ${token}`,
                              },
                            },
                          );
                          const resp = await response.json();
                          if (resp.exists) {
                            return "PAN number already exists";
                          }
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={updatePanNumber}
                placeHolder="Enter the PAN number"
                errorMessage={errors?.pan?.message ? errors?.pan?.message : ""}
                textBoxError={errors.pan ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                PF number&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Enter the Provident Fund number if applicable."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={pfNo}
                Icons={null}
                rules={{
                  ...register("pf", {
                    required: false,
                    validate: {
                      employeePFAvailable: async (fieldValue) => {
                        if (
                          fieldValue !== "" &&
                          employeeDetails.pf !== fieldValue
                        ) {
                          const response = await fetch(
                            `${domain}unique/identity-numbers/?pf=${fieldValue}`,
                            {
                              method: "GET",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `token ${token}`,
                              },
                            },
                          );
                          const resp = await response.json();
                          if (resp.exists) {
                            return "PF number Already Exists";
                          }
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={updatePFNumber}
                placeHolder="Enter the PF number"
                errorMessage={errors?.pf?.message ? errors?.pf?.message : ""}
                textBoxError={errors.pf ? true : false}
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                UAN number&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title=" Universal Account Number for EPF tracking."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={uanNo}
                Icons={null}
                rules={{
                  ...register("uan", {
                    required: false,
                    pattern: {
                      value: mustbe12Digits,
                      message: "Enter UAN in format 123456789012",
                    },

                    validate: {
                      employeeUANAvailable: async (fieldValue) => {
                        if (
                          fieldValue !== "" &&
                          employeeDetails.uan !== fieldValue
                        ) {
                          const response = await fetch(
                            `${domain}unique/identity-numbers/?uan=${fieldValue}`,
                            {
                              method: "GET",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `token ${token}`,
                              },
                            },
                          );
                          const resp = await response.json();
                          if (resp.exists) {
                            return "UAN number already exists";
                          }
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={updateUANNumber}
                placeHolder="Enter the UAN number"
                errorMessage={errors?.uan?.message ? errors?.uan?.message : ""}
                textBoxError={errors.uan ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                ESI number&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Employee's State Insurance number (if enrolled)."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={esiNo}
                Icons={null}
                rules={{
                  ...register("esi", {
                    required: false,
                    validate: {
                      employeeESIAvailable: async (fieldValue) => {
                        if (
                          fieldValue !== "" &&
                          employeeDetails.esi !== fieldValue
                        ) {
                          const response = await fetch(
                            `${domain}unique/identity-numbers/?esi=${fieldValue}`,
                            {
                              method: "GET",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `token ${token}`,
                              },
                            },
                          );
                          const resp = await response.json();
                          if (resp.exists) {
                            return "ESI number already exists";
                          }
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={updateESINumber}
                placeHolder="Enter the ESI number"
                errorMessage={errors?.esi?.message ? errors?.esi?.message : ""}
                textBoxError={errors.esi ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Date of Birth&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Enter the employee’s birth date."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <Mui.TextField
                type="date"
                value={dateOfBirth}
                Icons={null}
                inputProps={{
                  max: new Date().toISOString().split("T")[0], // Set the max date to today
                }}
                rules={{
                  ...register("dob", {
                    required: false,
                  }),
                }}
                size="small"
                onChange={(event) => {
                  handleDateOfBirth(event);
                }}
                helperText={errors?.dob?.message ? errors?.dob?.message : ""}
                error={errors.dob ? true : false}
                fullWidth
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Communication address&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Address for communication/correspondence."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                type="multiline"
                selectedValue={addressDetails}
                Icons={null}
                rules={{
                  ...register("address", {
                    required: false,
                  }),
                }}
                updateDataFunction={updateAddress}
                placeHolder="Enter Address"
                errorMessage={
                  errors?.address?.message ? errors?.address?.message : ""
                }
                textBoxError={errors.address ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Permanent address&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Enter permanent residence details."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                type="multiline"
                selectedValue={permanentAddressDetails}
                rules={{
                  ...register("permanent_address", {
                    required: false,
                  }),
                }}
                updateDataFunction={updatePermanentAddress}
                placeHolder="Enter Permanent Address"
                errorMessage={
                  errors?.permanent_address?.message
                    ? errors?.permanent_address?.message
                    : ""
                }
                textBoxError={errors.permanent_address ? true : false}
                disabledValue={
                  permanentAddressDetails === addressDetails ? true : false
                }
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }} />
          </Mui.Grid>
          <Mui.Grid container>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Gender&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Employee's gender as per official records."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomAutoComplete
                dataList={gender_type}
                selectedValue={genderType}
                rules={{
                  ...register("gender", {
                    required: false,
                  }),
                }}
                updateDataFunction={handleGenderType}
                placeHolder="Select the gender type"
                errorMessage={
                  errors?.gender?.message ? errors?.gender?.message : ""
                }
                textBoxError={errors?.gender ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Marital Status&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Employee's current marital status."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomAutoComplete
                dataList={maritial_status}
                selectedValue={maritialSts}
                rules={{
                  ...register("marital_status", {
                    required: false,
                  }),
                }}
                updateDataFunction={handleMaritialStatus}
                placeHolder="Select the marital status"
                errorMessage={
                  errors?.marital_status?.message
                    ? errors?.marital_status?.message
                    : ""
                }
                textBoxError={errors?.marital_status ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }} />
          </Mui.Grid>
          <Mui.Grid container sx={{ paddingBottom: 2 }}>
            <Mui.Checkbox
              checked={communicationAddressCheckBox}
              onChange={(event) => {
                setCommunicationAddressCheckBox(event.target.checked);
                if (event.target.checked) {
                  setValue("permanent_address", addressDetails);
                  setPermanentAddressDetails(addressDetails);
                } else {
                  setValue("permanent_address", "");
                  setPermanentAddressDetails("");
                }
              }}
              sx={{ "& .MuiSvgIcon-root": { fontSize: 35 } }}
            />{" "}
            <Mui.Typography
              sx={{ paddingTop: 1.5, fontSize: 18, color: themes.colorShadow }}
            >
              Is communication address same as permanent address
            </Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>
        {/* Transport */}
        <Mui.Grid
          container
          sx={{
            paddingBottom: { xs: 2, sm: 4, md: 4, lg: 5, xl: 5.5, xxl: 10 },
          }}
        />
        <Mui.Grid
          container
          sx={{
            border: `1px solid ${themes.sidebarDivider}`,
            borderRadius: 3,
          }}
        >
          <Mui.Grid
            container
            sx={{
              borderBottom: `1px solid ${themes.sidebarDivider}`,
              padding: {
                xs: 0.1,
                sm: 0.1,
                md: 0.2,
                lg: 0.3,
                xl: 0.5,
                xxl: 0.5,
              },
            }}
          >
            <Mui.Typography
              sx={{
                fontSize: 20,
                fontWeight: "bold",
                color: themes.headLine,
                paddingLeft: 1,
              }}
            >
              Mode of Stay/Transport
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Divider />
          <Mui.Grid container>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Employee use&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Select type (e.g., Company accommodation, Self-arranged)."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomAutoComplete
                dataList={employee_use}
                selectedValue={employeeUse}
                rules={{
                  ...register("transport_type", {
                    required: false,
                  }),
                }}
                updateDataFunction={handleEmployeeUse}
                placeHolder="Select the employee use"
                errorMessage={
                  errors?.transport_type?.message
                    ? errors?.transport_type?.message
                    : ""
                }
                textBoxError={errors?.transport_type ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                {employeeUse === "Company accommodation"
                  ? "Block Name"
                  : employeeUse === "Company transport"
                    ? "Transport root no"
                    : null}
                &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="If in company accommodation, specify block name."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              {employeeUse === "Company accommodation" ? (
                <CustomTextBox
                  selectedValue={blockNo}
                  rules={{
                    ...register("block_name", {
                      required: false,
                    }),
                  }}
                  updateDataFunction={updateBlockNumber}
                  placeHolder="Enter block name"
                  errorMessage={
                    errors?.block_name?.message
                      ? errors?.block_name?.message
                      : ""
                  }
                  textBoxError={errors.block_name ? true : false}
                />
              ) : employeeUse === "Company transport" ? (
                <CustomTextBox
                  selectedValue={transportRouteNumber}
                  rules={{
                    ...register("transport_route_no", {
                      required: false,
                    }),
                  }}
                  updateDataFunction={updateTransportRouteNumber}
                  placeHolder="Enter Route number"
                  errorMessage={
                    errors?.transport_route_no?.message
                      ? errors?.transport_route_no?.message
                      : ""
                  }
                  textBoxError={errors.transport_route_no ? true : false}
                />
              ) : null}
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              {employeeUse === "Company accommodation" ? (
                <>
                  <Mui.Typography
                    sx={{
                      fontSize: 15,
                      color: themes.headLine,
                      paddingBottom: 0.5,
                      fontWeight: "bold",
                    }}
                  >
                    Room No&nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Specify room number allocated to the employee."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                  <CustomTextBox
                    selectedValue={roomNo}
                    rules={{
                      ...register("room_no", {
                        required: false,
                      }),
                    }}
                    updateDataFunction={updateRoomNumber}
                    placeHolder="Enter room number"
                    errorMessage={
                      errors?.room_no?.message ? errors?.room_no?.message : ""
                    }
                    textBoxError={errors.room_no ? true : false}
                  />
                </>
              ) : null}
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
        {/* Contact Info */}
        <Mui.Grid
          container
          sx={{
            paddingBottom: { xs: 2, sm: 4, md: 4, lg: 5, xl: 5.5, xxl: 10 },
          }}
        />
        <Mui.Grid
          container
          sx={{
            border: `1px solid ${themes.sidebarDivider}`,
            borderRadius: 3,
          }}
        >
          <Mui.Grid
            container
            sx={{
              borderBottom: `1px solid ${themes.sidebarDivider}`,
              padding: {
                xs: 0.1,
                sm: 0.1,
                md: 0.2,
                lg: 0.3,
                xl: 0.5,
                xxl: 0.5,
              },
            }}
          >
            <Mui.Typography
              sx={{
                fontSize: 20,
                fontWeight: "bold",
                color: themes.headLine,
                paddingLeft: 1,
              }}
            >
              Contact Info
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Divider />
          <Mui.Box sx={{ p: 1 }}>
            <Mui.TableContainer sx={{ width: "100%" }}>
              <Mui.Table className="border">
                <Mui.TableHead sx={tableHeaderSx}>
                  <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                    <Mui.TableCell
                      sx={{ color: themes.headLine, fontWeight: "bold" }}
                    >
                      Contact Name
                    </Mui.TableCell>{" "}
                    <Mui.TableCell
                      sx={{ color: themes.headLine, fontWeight: "bold" }}
                    >
                      Relation Type
                    </Mui.TableCell>{" "}
                    <Mui.TableCell
                      sx={{ color: themes.headLine, fontWeight: "bold" }}
                    >
                      Contact Number
                    </Mui.TableCell>{" "}
                    <Mui.TableCell
                      sx={{ color: themes.headLine, fontWeight: "bold" }}
                    ></Mui.TableCell>
                  </Mui.TableRow>
                </Mui.TableHead>
                {rows.map((row, index) => (
                  <Mui.TableBody key={index}>
                    <Mui.TableCell>
                      <Mui.TextField
                        size="small"
                        value={row.contact_name}
                        onChange={(e) => {
                          const val = e.target.value;
                          const validPattern = /^[A-Za-z ]*$/;
                          if (val === "" || validPattern.test(val)) {
                            handleChange(index, "contact_name", val);
                          }
                        }}
                        error={rowError[index]?.contact_name}
                        helperText={
                          rowError[index]?.contact_name
                            ? row.contact_name.trim() === ""
                              ? "Enter contact name"
                              : "Name must contain only letters"
                            : ""
                        }
                        placeholder="Enter name"
                      />
                    </Mui.TableCell>

                    <Mui.TableCell>
                      <Mui.TextField
                        size="small"
                        value={row.relation_type}
                        onChange={(e) => {
                          const val = e.target.value;
                          const validPattern = /^[A-Za-z ]*$/;
                          if (val === "" || validPattern.test(val)) {
                            handleChange(index, "relation_type", val);
                          }
                        }}
                        error={rowError[index]?.relation_type}
                        helperText={
                          rowError[index]?.relation_type
                            ? row.relation_type.trim() === ""
                              ? "Enter relation"
                              : index > 0 &&
                                  row.relation_type.trim().toLowerCase() ===
                                    rows[index - 1].relation_type
                                      .trim()
                                      .toLowerCase()
                                ? `Relation must be unique — previous: ${
                                    rows[index - 1].relation_type
                                  }`
                                : "Invalid relation type"
                            : ""
                        }
                        placeholder="Enter relation"
                      />
                    </Mui.TableCell>

                    <Mui.TableCell>
                      <Mui.TextField
                        size="small"
                        value={row.contact_number}
                        onChange={(e) => {
                          const val = e.target.value;
                          const validPattern = /^[0-9]{0,10}$/;
                          if (validPattern.test(val)) {
                            handleChange(index, "contact_number", val);
                          }
                        }}
                        error={rowError[index]?.contact_number}
                        helperText={
                          rowError[index]?.contact_number
                            ? row.contact_number.trim() === ""
                              ? "Enter contact number"
                              : row.contact_number.trim().length !== 10
                                ? "Number must be 10 digits"
                                : index > 0 &&
                                    row.contact_number ===
                                      rows[index - 1].contact_number
                                  ? `Number must be unique — previous: ${
                                      rows[index - 1].contact_number
                                    }`
                                  : "Invalid number"
                            : ""
                        }
                        placeholder="Enter number"
                      />
                    </Mui.TableCell>

                    <Mui.TableCell>
                      <Mui.IconButton
                        onClick={() => handleRemoveRow(index)}
                        disabled={rows?.length === 1}
                      >
                        <Cancel />
                      </Mui.IconButton>
                    </Mui.TableCell>
                  </Mui.TableBody>
                ))}
              </Mui.Table>
            </Mui.TableContainer>
            <Mui.Grid container>
              <Mui.Grid item xs={10.75}></Mui.Grid>
              <Mui.Grid item xs={1}>
                <Mui.IconButton onClick={handleAddRow}>
                  <AddCircleTwoTone />
                </Mui.IconButton>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Box>
        </Mui.Grid>
        {/* Bank Info */}
        <Mui.Grid
          container
          sx={{
            paddingBottom: { xs: 2, sm: 4, md: 4, lg: 5, xl: 5.5, xxl: 10 },
          }}
        />
        <Mui.Grid
          container
          sx={{
            border: `1px solid ${themes.sidebarDivider}`,
            borderRadius: 3,
          }}
        >
          <Mui.Grid
            container
            sx={{
              borderBottom: `1px solid ${themes.sidebarDivider}`,
              padding: {
                xs: 0.1,
                sm: 0.1,
                md: 0.2,
                lg: 0.3,
                xl: 0.5,
                xxl: 0.5,
              },
            }}
          >
            <Mui.Typography
              sx={{
                fontSize: 20,
                fontWeight: "bold",
                color: themes.headLine,
                paddingLeft: 1,
              }}
            >
              Bank Info
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Divider />
          <Mui.Grid container>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Account Holder Name&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Name as per bank records."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={accountNameDetails}
                rules={{
                  ...register("account_holder_name", {
                    required: false,
                    validate: {
                      minLengthNoSpaces: (value) => {
                        if (value?.trim().length < 3 && value !== "") {
                          return minimum3Characters;
                        } else {
                          return true;
                        }
                      },
                      atleastOneCharacterWithSpaceReg: (value) => {
                        if (
                          atleastOneCharacterWithSpace.test(value) ||
                          value === ""
                        ) {
                          return true;
                        } else {
                          return "Atleast one alphabet required";
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={updateAccountName}
                placeHolder="Enter Account Name"
                errorMessage={
                  errors?.account_holder_name?.message
                    ? errors?.account_holder_name?.message
                    : ""
                }
                textBoxError={errors.account_holder_name ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Bank Name&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Enter the employee's bank name."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={bankNameDetails}
                rules={{
                  ...register("bankname", {
                    required: false,
                    validate: {
                      minLengthNoSpaces: (value) => {
                        if (value?.trim().length < 3 && value !== "") {
                          return minimum3Characters;
                        } else {
                          return true;
                        }
                      },
                      atleastOneCharacterWithSpaceReg: (value) => {
                        if (
                          atleastOneCharacterWithSpace.test(value) ||
                          value === ""
                        ) {
                          return true;
                        } else {
                          return "Atleast one alphabet required";
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={updateBankName}
                placeHolder="Enter Bank Name"
                errorMessage={
                  errors?.bankname?.message ? errors?.bankname?.message : ""
                }
                textBoxError={errors.bankname ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Bank Account Number&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Employee's active bank account for salary credit.
"
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={accountNumber}
                rules={{
                  ...register("accountno", {
                    required: false,
                  }),
                }}
                updateDataFunction={updateBankAccountNumber}
                placeHolder="Enter Bank Account Number"
                errorMessage={
                  errors?.accountno?.message ? errors?.accountno?.message : ""
                }
                textBoxError={errors.accountno ? true : false}
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                IFSC code&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="IFSC for NEFT/RTGS payments.
"
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={ifscCodeDetails}
                rules={{
                  ...register("ifsc", {
                    required: false,
                    validate: {
                      minLengthNoSpaces: (value) => {
                        const trimmedValue = value?.trim();
                        if (!trimmedValue) {
                          return true;
                        }
                        if (trimmedValue.length < 11) {
                          return "Minimum 11 characters required";
                        }
                        if (!ifscCodePatterns.test(trimmedValue)) {
                          return "Enter a valid format: ABCD0123456";
                        }

                        return true;
                      },
                    },
                  }),
                }}
                updateDataFunction={updateIFSCcode}
                placeHolder="Enter IFSC Code"
                errorMessage={
                  errors?.ifsc?.message ? errors?.ifsc?.message : ""
                }
                textBoxError={errors.ifsc ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Address&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Address of the bank or branch."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={bankAddress}
                Icons={null}
                rules={{
                  ...register("bank_address", {
                    required: false,
                    validate: {
                      minLengthNoSpaces: (value) => {
                        if (value?.trim().length < 3 && value !== "") {
                          return minimum3Characters;
                        } else {
                          return true;
                        }
                      },
                      atleastOneCharacterWithSpaceReg: (value) => {
                        if (
                          atleastOneCharacterWithSpace.test(value) ||
                          value === ""
                        ) {
                          return true;
                        } else {
                          return "Atleast one alphabet required";
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={updateBankAddress}
                placeHolder="Enter Address"
                errorMessage={
                  errors?.bank_address?.message
                    ? errors?.bank_address?.message
                    : ""
                }
                textBoxError={errors.bank_address ? true : false}
              />
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid
          container
          sx={{
            paddingBottom: { xs: 2, sm: 4, md: 4, lg: 5, xl: 5.5, xxl: 10 },
          }}
        />
        <Mui.Grid container sx={{ padding: 2 }}>
          <Mui.Grid xs={1}>
            <CustomButton
              actionFuntion={() => {
                dispatch(setEditPage(1));
                setUpdateUserDetails(true);
              }}
              actionName="Previous"
              typeName="button"
            />
          </Mui.Grid>
          <Mui.Grid xs={1.5}>
            <CustomButton
              actionFuntion={() => {
                setSaveAndExit(true);
              }}
              actionName="Save & Exit"
              typeName="submit"
            />
          </Mui.Grid>
          <Mui.Grid xs={7.5}></Mui.Grid>
          <Mui.Grid
            xs={2}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <CustomButton actionName="Next" typeName="submit" />
          </Mui.Grid>
        </Mui.Grid>
      </form>
    </React.Fragment>
  );
};
